import api from './api';
import Axios from 'axios';
import { getJwt } from '@app/helpers';
import { notification } from '@digital/ui';
import { PaginationResult } from './pendenciaDocumental';

export interface ControleSuspensaoItem {
  id: string;
  contratoId: string;
  numeroContrato: number | null;
  administradorContratoId: string | null;
  administradorContrato: string | null;
  destinatario: string | null;
  envioData: string | null;
  envioCodigoRastreio: string | null;
  envioPrazoData: string | null;
  bloqueioAtivo: boolean;
  dataDesbloqueio: string | null;
  justificativaDesbloqueio: string | null;
  usuarioDesbloqueio: string | null;
}

export interface ControleSuspensaoResult {
  bloqueios: PaginationResult<ControleSuspensaoItem>;
  administradoresContrato: string[];
  numerosContrato: number[];
}

export const getControleSuspensao = (params: {
  admContratoId?: string;
  numeroContrato?: number;
  statusBloqueio?: string;
  page?: number;
  pageSize?: number;
}) => {
  const qs = new URLSearchParams();
  if (params.admContratoId) qs.set('admContratoId', params.admContratoId);
  if (params.numeroContrato) qs.set('numeroContrato', String(params.numeroContrato));
  if (params.statusBloqueio) qs.set('statusBloqueio', params.statusBloqueio);
  qs.set('page', String(params.page || 1));
  qs.set('pageSize', String(params.pageSize || 20));
  return api.get<ControleSuspensaoResult>('controleSuspensao?' + qs.toString());
};

export const desbloquearPagamento = (id: string, justificativa: string) =>
  api.post<any>(`controleSuspensao/${id}/desbloquear`, { justificativa });

export const exportarControleSuspensao = (params: {
  admContratoId?: string;
  numeroContrato?: number;
  statusBloqueio?: string;
}) => {
  const qs = new URLSearchParams();
  if (params.admContratoId) qs.set('admContratoId', params.admContratoId);
  if (params.numeroContrato) qs.set('numeroContrato', String(params.numeroContrato));
  if (params.statusBloqueio) qs.set('statusBloqueio', params.statusBloqueio);
  const url = window.location.origin + '/api/controleSuspensao/exportar?' + qs.toString();
  return Axios.get(url, {
    responseType: 'blob',
    headers: { Authorization: 'Bearer ' + getJwt() },
  }).then(function(resp) {
    const tipo = resp.data && resp.data.type ? resp.data.type : '';
    if (tipo.indexOf('json') !== -1 || tipo.indexOf('html') !== -1) {
      notification.error('Houve um erro ao exportar.');
      return;
    }
    const blobUrl = window.URL.createObjectURL(new Blob([resp.data]));
    const link = document.createElement('a');
    link.href = blobUrl;
    link.setAttribute('download', 'controle_suspensao.xlsx');
    link.setAttribute('id', 'download-controle-suspensao');
    document.body.appendChild(link);
    link.click();
    const el = document.getElementById('download-controle-suspensao');
    if (el) el.outerHTML = '';
  }).catch(function() {
    notification.error('Houve um erro ao exportar.');
  });
};
